import { type Dispatch, type SetStateAction, useState } from 'react';
import { NavbarMenuListContext } from './NavbarMenuListContext';

export interface NavbarMenuListContextType {
  middleWrapperHeight: number;
  setMiddleWrapperHeight: Dispatch<SetStateAction<number>>;
}

export function NavbarMenuListContextProvider(props: { children: React.ReactNode }) {
  const { children } = props;
  const [middleWrapperHeight, setMiddleWrapperHeight] = useState<number>(0);

  return (
    <NavbarMenuListContext.Provider value={{ middleWrapperHeight, setMiddleWrapperHeight }}>
      {children}
    </NavbarMenuListContext.Provider>
  );
}
